import { AfterViewInit, Component, OnDestroy, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

import { MainMenuComponent } from '../../shared/main-menu/main-menu.component';
import { AboutMenuComponent } from '../../shared/about-menu/about-menu.component';
import { ScriptLoaderService, VENDOR_SCRIPTS } from '../../script-loader.service';
import { ManagementProfile } from '../../shared/models/management.model';
import { SubscribeComponent } from '../../shared/subscribe/subscribe.component';
@Component({
  selector: 'app-management',
  standalone: true,
  imports: [CommonModule, RouterLink, MainMenuComponent, AboutMenuComponent, SubscribeComponent],
  templateUrl: '../templates/management.component.html',
  styleUrls: ['../css/management.component.css']
})

export class ManagementComponent implements OnInit, AfterViewInit, OnDestroy {
  readonly managementProfiles = signal<ManagementProfile[]>([]);

  constructor(private readonly scriptLoader: ScriptLoaderService) { }

  ngOnInit(): void {
    this.loadManagementProfiles();
  }

  ngAfterViewInit(): void {
    document.body.classList.add('defult-home');
    this.scriptLoader
      .loadSequential(...VENDOR_SCRIPTS)
      .then(() => {
        // If vendor scripts were injected after the native load event,
        // re-dispatch it so jQuery load handlers in main.js still run.
        if (document.readyState === 'complete') {
          window.dispatchEvent(new Event('load'));
        }
        // Ensure sticky menu is properly initialized
        setTimeout(() => {
          this.initializeStickyMenu();
          window.dispatchEvent(new Event('scroll'));
        }, 150);
      })
      .catch((error) => {
        console.error('Failed to load third-party scripts', error);
      });
  }

  private initializeStickyMenu(): void {
    const $ = (window as any).jQuery;
    if ($ && typeof $ === 'function') {
      const header = $('.menu-sticky');
      const scroll = $(window).scrollTop() || 0;
      if (scroll > 0) {
        header.addClass('sticky');
      } else {
        header.removeClass('sticky');
      }
    }
  }

  ngOnDestroy(): void {
    document.body.classList.remove('defult-home');
  }

  trackById(_: number, profile: ManagementProfile): string {
    return profile.id;
  }

  private async loadManagementProfiles(): Promise<void> {
    try {
      const response = await fetch('https://jntuanotifications.blob.core.windows.net/websites/management-profiles.json');
      if (!response.ok) {
        throw new Error(`Failed to load management profiles: ${response.status}`);
      }

      const profiles = (await response.json()) as ManagementProfile[];
      this.managementProfiles.set(
        profiles.filter(profile => !['society', 'insurance', 'sevasamithi'].includes(profile.id))
      );
    } catch (error) {
      console.error('Failed to load management profiles JSON', error);
      this.managementProfiles.set([]);
    }
  }
}

